import Popup from '../components/Popup'
import Button from '../components/Button'
import React from 'react'
import { CheckBox } from '../components/CheckBox'

export interface WiserPromptPopupProps {
  onYes: (doNotAskAgain: boolean) => void
  onNo?: (doNotAskAgain: boolean) => void
  children: React.ReactNode
}

export function WiserPromptPopup({
  onYes,
  onNo,
  children,
}: WiserPromptPopupProps) {
  const [doNotAskAgain, setDoNotAskAgain] = React.useState(false)

  return (
    <Popup onClose={() => { return }}>
      <div className="title">
        {children}
      </div>
      <div style={{ textAlign: 'center', margin: '10px 0 30px 0', display: 'flex', justifyContent: 'center' }}>
        <CheckBox checked={doNotAskAgain} setChecked={setDoNotAskAgain}>
          {
            onNo
              ? 'Do not ask me again'
              : 'Do not show me this again'
          }
        </CheckBox>
      </div>
      <div className="buttonStack">
        <div className="buttonRow">
          <Button buttonStyle="green" onClick={() => onYes(doNotAskAgain)}>
            {
              onNo ? 'Yes' : 'Ok'
            }
          </Button>
          {
            onNo && (
              <Button buttonStyle="default" onClick={() => onNo(doNotAskAgain)}>
                No
              </Button>
            )
          }
        </div>
      </div>
    </Popup>
  )
}
